import { EditorContent, type EditorContentProps } from '@tiptap/react';
import './message-tiptap.css';

const PdkEditorContent = (editorProp: EditorContentProps) => {
  return (
    <div className="message-tiptap">
      <EditorContent {...editorProp} />
    </div>
  );
};

export default PdkEditorContent;
